import * as yup from 'yup';

export interface PhoneNumberValue {
  countryCode: string;
  number: string;
}

export interface CountryDialCode {
  name: string;
  code: string;
}

export const DEFAULT_COUNTRY_CODE = '47';
export const NORWEGIAN_PHONE_LENGTH = 8;
const E164_MAX_TOTAL_LENGTH = 15;
const NUMBER_MIN_LENGTH = 4;

export const COUNTRY_DIAL_CODES: CountryDialCode[] = [
  { name: 'Norge', code: '47' },
  { name: 'Afghanistan', code: '93' },
  { name: 'Albania', code: '355' },
  { name: 'Algerie', code: '213' },
  { name: 'Andorra', code: '376' },
  { name: 'Angola', code: '244' },
  { name: 'Argentina', code: '54' },
  { name: 'Armenia', code: '374' },
  { name: 'Aserbajdsjan', code: '994' },
  { name: 'Australia', code: '61' },
  { name: 'Bahrain', code: '973' },
  { name: 'Bangladesh', code: '880' },
  { name: 'Belarus', code: '375' },
  { name: 'Belgia', code: '32' },
  { name: 'Belize', code: '501' },
  { name: 'Benin', code: '229' },
  { name: 'Bhutan', code: '975' },
  { name: 'Bolivia', code: '591' },
  { name: 'Bosnia-Hercegovina', code: '387' },
  { name: 'Botswana', code: '267' },
  { name: 'Brasil', code: '55' },
  { name: 'Brunei', code: '673' },
  { name: 'Bulgaria', code: '359' },
  { name: 'Burkina Faso', code: '226' },
  { name: 'Burundi', code: '257' },
  { name: 'Chile', code: '56' },
  { name: 'Colombia', code: '57' },
  { name: 'Costa Rica', code: '506' },
  { name: 'Cuba', code: '53' },
  { name: 'Curaçao', code: '599' },
  { name: 'Danmark', code: '45' },
  { name: 'Den dominikanske republikk', code: '1809' },
  { name: 'Den sentralafrikanske republikk', code: '236' },
  { name: 'Djibouti', code: '253' },
  { name: 'Ecuador', code: '593' },
  { name: 'Egypt', code: '20' },
  { name: 'Ekvatorial-Guinea', code: '240' },
  { name: 'El Salvador', code: '503' },
  { name: 'Elfenbenskysten', code: '225' },
  { name: 'Eritrea', code: '291' },
  { name: 'Estland', code: '372' },
  { name: 'Eswatini', code: '268' },
  { name: 'Etiopia', code: '251' },
  { name: 'Filippinene', code: '63' },
  { name: 'Finland', code: '358' },
  { name: 'Forente arabiske emirater', code: '971' },
  { name: 'Frankrike', code: '33' },
  { name: 'Gabon', code: '241' },
  { name: 'Gambia', code: '220' },
  { name: 'Georgia', code: '995' },
  { name: 'Ghana', code: '233' },
  { name: 'Gibraltar', code: '350' },
  { name: 'Grenada', code: '1473' },
  { name: 'Grønland', code: '299' },
  { name: 'Guatemala', code: '502' },
  { name: 'Guinea', code: '224' },
  { name: 'Guinea-Bissau', code: '245' },
  { name: 'Guyana', code: '592' },
  { name: 'Haiti', code: '509' },
  { name: 'Hellas', code: '30' },
  { name: 'Honduras', code: '504' },
  { name: 'Hongkong', code: '852' },
  { name: 'India', code: '91' },
  { name: 'Indonesia', code: '62' },
  { name: 'Irak', code: '964' },
  { name: 'Iran', code: '98' },
  { name: 'Irland', code: '353' },
  { name: 'Island', code: '354' },
  { name: 'Israel', code: '972' },
  { name: 'Italia', code: '39' },
  { name: 'Jamaica', code: '1876' },
  { name: 'Japan', code: '81' },
  { name: 'Jemen', code: '967' },
  { name: 'Jordan', code: '962' },
  { name: 'Kambodsja', code: '855' },
  { name: 'Kamerun', code: '237' },
  { name: 'Kanada', code: '1' },
  { name: 'Kapp Verde', code: '238' },
  { name: 'Kasakhstan', code: '7' },
  { name: 'Kenya', code: '254' },
  { name: 'Kina', code: '86' },
  { name: 'Kirgisistan', code: '996' },
  { name: 'Kiribati', code: '686' },
  { name: 'Komorene', code: '269' },
  { name: 'Kongo (Brazzaville)', code: '242' },
  { name: 'Kongo (Kinshasa)', code: '243' },
  { name: 'Kosovo', code: '383' },
  { name: 'Kroatia', code: '385' },
  { name: 'Kuwait', code: '965' },
  { name: 'Kypros', code: '357' },
  { name: 'Laos', code: '856' },
  { name: 'Latvia', code: '371' },
  { name: 'Lesotho', code: '266' },
  { name: 'Libanon', code: '961' },
  { name: 'Liberia', code: '231' },
  { name: 'Libya', code: '218' },
  { name: 'Liechtenstein', code: '423' },
  { name: 'Litauen', code: '370' },
  { name: 'Luxembourg', code: '352' },
  { name: 'Madagaskar', code: '261' },
  { name: 'Malawi', code: '265' },
  { name: 'Malaysia', code: '60' },
  { name: 'Maldivene', code: '960' },
  { name: 'Mali', code: '223' },
  { name: 'Malta', code: '356' },
  { name: 'Marokko', code: '212' },
  { name: 'Mauritania', code: '222' },
  { name: 'Mauritius', code: '230' },
  { name: 'Mexico', code: '52' },
  { name: 'Moldova', code: '373' },
  { name: 'Monaco', code: '377' },
  { name: 'Mongolia', code: '976' },
  { name: 'Montenegro', code: '382' },
  { name: 'Mosambik', code: '258' },
  { name: 'Myanmar', code: '95' },
  { name: 'Namibia', code: '264' },
  { name: 'Nederland', code: '31' },
  { name: 'Nepal', code: '977' },
  { name: 'New Zealand', code: '64' },
  { name: 'Nicaragua', code: '505' },
  { name: 'Niger', code: '227' },
  { name: 'Nigeria', code: '234' },
  { name: 'Nord-Korea', code: '850' },
  { name: 'Nord-Makedonia', code: '389' },
  { name: 'Oman', code: '968' },
  { name: 'Pakistan', code: '92' },
  { name: 'Palestina', code: '970' },
  { name: 'Panama', code: '507' },
  { name: 'Papua Ny-Guinea', code: '675' },
  { name: 'Paraguay', code: '595' },
  { name: 'Peru', code: '51' },
  { name: 'Polen', code: '48' },
  { name: 'Portugal', code: '351' },
  { name: 'Qatar', code: '974' },
  { name: 'Romania', code: '40' },
  { name: 'Russland', code: '7' },
  { name: 'Rwanda', code: '250' },
  { name: 'San Marino', code: '378' },
  { name: 'Saudi-Arabia', code: '966' },
  { name: 'Senegal', code: '221' },
  { name: 'Serbia', code: '381' },
  { name: 'Seychellene', code: '248' },
  { name: 'Sierra Leone', code: '232' },
  { name: 'Singapore', code: '65' },
  { name: 'Slovakia', code: '421' },
  { name: 'Slovenia', code: '386' },
  { name: 'Somalia', code: '252' },
  { name: 'Spania', code: '34' },
  { name: 'Sri Lanka', code: '94' },
  { name: 'Storbritannia', code: '44' },
  { name: 'Sudan', code: '249' },
  { name: 'Surinam', code: '597' },
  { name: 'Sveits', code: '41' },
  { name: 'Sverige', code: '46' },
  { name: 'Syria', code: '963' },
  { name: 'Sør-Afrika', code: '27' },
  { name: 'Sør-Korea', code: '82' },
  { name: 'Sør-Sudan', code: '211' },
  { name: 'Tadsjikistan', code: '992' },
  { name: 'Taiwan', code: '886' },
  { name: 'Tanzania', code: '255' },
  { name: 'Thailand', code: '66' },
  { name: 'Togo', code: '228' },
  { name: 'Tsjad', code: '235' },
  { name: 'Tsjekkia', code: '420' },
  { name: 'Tunisia', code: '216' },
  { name: 'Turkmenistan', code: '993' },
  { name: 'Tyrkia', code: '90' },
  { name: 'Tyskland', code: '49' },
  { name: 'Uganda', code: '256' },
  { name: 'Ukraina', code: '380' },
  { name: 'Ungarn', code: '36' },
  { name: 'Uruguay', code: '598' },
  { name: 'USA', code: '1' },
  { name: 'Usbekistan', code: '998' },
  { name: 'Vanuatu', code: '678' },
  { name: 'Vatikanstaten', code: '379' },
  { name: 'Venezuela', code: '58' },
  { name: 'Vietnam', code: '84' },
  { name: 'Zambia', code: '260' },
  { name: 'Zimbabwe', code: '263' },
  { name: 'Færøyene', code: '298' },
  { name: 'Øst-Timor', code: '670' },
  { name: 'Østerrike', code: '43' },
];

const COUNTRY_BY_CODE = new Map(COUNTRY_DIAL_CODES.map((c) => [c.code, c]));

const COUNTRY_CODES_BY_LENGTH_DESC = [...COUNTRY_DIAL_CODES].sort((a, b) => b.code.length - a.code.length);

export const findCountryByCode = (code: string): CountryDialCode | undefined => COUNTRY_BY_CODE.get(code);

const ERROR_REQUIRED = 'Vennligst fyll inn dette feltet.';
const ERROR_LANDKODE_PREFIX = 'Skriv mobilnummeret uten landkode (f.eks. 91234567).';
const ERROR_DIGITS_ONLY = 'Mobilnummeret kan kun inneholde tall.';
const ERROR_LENGTH_NORWEGIAN = `Norske mobilnummer skal ha ${NORWEGIAN_PHONE_LENGTH} siffer.`;
const ERROR_LENGTH_GENERIC = 'Ugyldig mobilnummer for valgt land.';

/**
 * National (subscriber) number length per dial code (mobile-oriented, trunk "0" excluded).
 * Coverage: Norway + all EU member states + Iceland, UK and USA/Canada. Ranges are intentionally
 * lenient — the membership backend is the source of truth on submit; this is early UX feedback
 * only. Dial codes not listed fall back to a generic E.164 check.
 */
export const COUNTRY_PHONE_RULES: Record<string, { min: number; max: number }> = {
  '47': { min: NORWEGIAN_PHONE_LENGTH, max: NORWEGIAN_PHONE_LENGTH }, // Norge
  '32': { min: 8, max: 9 }, // Belgia
  '359': { min: 8, max: 9 }, // Bulgaria
  '45': { min: 8, max: 8 }, // Danmark
  '372': { min: 7, max: 8 }, // Estland
  '358': { min: 6, max: 10 }, // Finland
  '33': { min: 9, max: 9 }, // Frankrike
  '30': { min: 10, max: 10 }, // Hellas
  '353': { min: 7, max: 9 }, // Irland
  '354': { min: 7, max: 7 }, // Island
  '39': { min: 9, max: 10 }, // Italia
  '385': { min: 8, max: 9 }, // Kroatia
  '357': { min: 8, max: 8 }, // Kypros
  '371': { min: 8, max: 8 }, // Latvia
  '370': { min: 8, max: 8 }, // Litauen
  '352': { min: 8, max: 9 }, // Luxembourg
  '356': { min: 8, max: 8 }, // Malta
  '31': { min: 9, max: 9 }, // Nederland
  '48': { min: 9, max: 9 }, // Polen
  '351': { min: 9, max: 9 }, // Portugal
  '40': { min: 9, max: 9 }, // Romania
  '421': { min: 9, max: 9 }, // Slovakia
  '386': { min: 8, max: 8 }, // Slovenia
  '34': { min: 9, max: 9 }, // Spania
  '44': { min: 9, max: 10 }, // Storbritannia
  '46': { min: 7, max: 9 }, // Sverige
  '420': { min: 9, max: 9 }, // Tsjekkia
  '49': { min: 10, max: 11 }, // Tyskland
  '36': { min: 9, max: 9 }, // Ungarn
  '1': { min: 10, max: 10 }, // USA/Canada
  '43': { min: 8, max: 13 }, // Østerrike (svært variabel lengde)
};

export interface ValidatePhoneOptions {
  required: boolean;
}

export const validatePhoneNumber = (
  value: PhoneNumberValue | undefined | null,
  { required }: ValidatePhoneOptions,
): true | string => {
  const rawNumber = value?.number?.trim() ?? '';
  if (!rawNumber) {
    return required ? ERROR_REQUIRED : true;
  }

  if (rawNumber.startsWith('+') || rawNumber.startsWith('00')) {
    return ERROR_LANDKODE_PREFIX;
  }

  if (!/^\d+$/.test(rawNumber)) {
    return ERROR_DIGITS_ONLY;
  }

  const countryCode = value?.countryCode?.trim() || DEFAULT_COUNTRY_CODE;

  const rule = COUNTRY_PHONE_RULES[countryCode];
  if (rule) {
    if (rawNumber.length < rule.min || rawNumber.length > rule.max) {
      return countryCode === DEFAULT_COUNTRY_CODE ? ERROR_LENGTH_NORWEGIAN : ERROR_LENGTH_GENERIC;
    }
    return true;
  }

  const maxLength = E164_MAX_TOTAL_LENGTH - countryCode.length;
  if (rawNumber.length < NUMBER_MIN_LENGTH || rawNumber.length > maxLength) {
    return ERROR_LENGTH_GENERIC;
  }

  return true;
};

export const formatPhoneNumber = ({ countryCode, number }: PhoneNumberValue): string => {
  const digitsOnly = (number ?? '').replace(/\D/g, '');
  if (!digitsOnly) {
    return '';
  }
  return `+${countryCode}${digitsOnly}`;
};

export const parsePhoneNumber = (stored: string | null | undefined): PhoneNumberValue => {
  const fallback = { countryCode: DEFAULT_COUNTRY_CODE, number: '' };
  if (!stored) {
    return fallback;
  }
  const trimmed = stored.trim();
  if (!trimmed.startsWith('+')) {
    return { countryCode: DEFAULT_COUNTRY_CODE, number: trimmed.replace(/\D/g, '') };
  }
  const digits = trimmed.slice(1).replace(/\D/g, '');
  const match = COUNTRY_CODES_BY_LENGTH_DESC.find((c) => digits.startsWith(c.code));
  if (!match) {
    return { countryCode: DEFAULT_COUNTRY_CODE, number: digits };
  }
  return { countryCode: match.code, number: digits.slice(match.code.length) };
};

/**
 * Builds a PhoneNumberValue from the backend's separate `phoneNumber` and `phoneNumberPrefix`
 * fields. When no prefix is supplied, falls back to parsing the dial code out of the number.
 */
export const toPhoneNumberValue = (number: string | null | undefined, prefix?: string | null): PhoneNumberValue => {
  const trimmedPrefix = prefix?.trim();
  if (!trimmedPrefix) {
    return parsePhoneNumber(number);
  }
  return { countryCode: trimmedPrefix, number: (number ?? '').replace(/\D/g, '') };
};

/**
 * Formats the backend's separate `phoneNumber` and `phoneNumberPrefix` fields for read-only
 * display, e.g. `+47 91234567`. Returns an empty string when there is no number to show.
 */
export const formatDisplayPhoneNumber = (number: string | null | undefined, prefix?: string | null): string =>
  number ? `+${prefix?.trim() || DEFAULT_COUNTRY_CODE} ${number}` : '';

export interface PhoneSchemaOptions {
  required: boolean;
}

export const phoneNumberSchema = ({ required }: PhoneSchemaOptions) =>
  yup
    .object({
      countryCode: yup.string().default(DEFAULT_COUNTRY_CODE),
      number: yup.string().default(''),
    })
    .test('phone-number', function test(value) {
      const result = validatePhoneNumber(value as PhoneNumberValue, { required });
      if (result === true) {
        return true;
      }
      return this.createError({ message: result });
    });

export const phoneNumberRules = ({ required }: PhoneSchemaOptions) => ({
  validate: (value: PhoneNumberValue | undefined) => validatePhoneNumber(value, { required }),
});
